"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLaunchPromoDto = instanceOfLaunchPromoDto;
exports.LaunchPromoDtoFromJSON = LaunchPromoDtoFromJSON;
exports.LaunchPromoDtoFromJSONTyped = LaunchPromoDtoFromJSONTyped;
exports.LaunchPromoDtoToJSON = LaunchPromoDtoToJSON;
exports.LaunchPromoDtoToJSONTyped = LaunchPromoDtoToJSONTyped;
/**
 * Check if a given object implements the LaunchPromoDto interface.
 */
function instanceOfLaunchPromoDto(value) {
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('introPriceAmount' in value) || value['introPriceAmount'] === undefined)
        return false;
    if (!('listPriceAmount' in value) || value['listPriceAmount'] === undefined)
        return false;
    if (!('offeringId' in value) || value['offeringId'] === undefined)
        return false;
    return true;
}
function LaunchPromoDtoFromJSON(json) {
    return LaunchPromoDtoFromJSONTyped(json, false);
}
function LaunchPromoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isActive': json['isActive'],
        'startsAt': json['startsAt'] == null ? undefined : json['startsAt'],
        'endsAt': json['endsAt'] == null ? undefined : json['endsAt'],
        'introPriceAmount': json['introPriceAmount'],
        'listPriceAmount': json['listPriceAmount'],
        'offeringId': json['offeringId'],
    };
}
function LaunchPromoDtoToJSON(json) {
    return LaunchPromoDtoToJSONTyped(json, false);
}
function LaunchPromoDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'isActive': value['isActive'],
        'startsAt': value['startsAt'],
        'endsAt': value['endsAt'],
        'introPriceAmount': value['introPriceAmount'],
        'listPriceAmount': value['listPriceAmount'],
        'offeringId': value['offeringId'],
    };
}
